import apiClient from './client'
import {
  User,
  UserRole,
  UserStatus,
  PaginatedResponse,
} from '../types'

const ENDPOINT = '/users'

export interface UserCreateRequest {
  email: string
  password: string
  name: string
  phone: string
  role: UserRole
  tenant_id?: string
}

export interface UserUpdateRequest {
  name?: string
  phone?: string
  role?: UserRole
  status?: UserStatus
  tenant_id?: string
}

export const userApi = {
  getUsers: async (
    page = 1,
    limit = 20,
    role?: UserRole,
    status?: UserStatus,
  ) => {
    const params = new URLSearchParams()
    params.append('page', page.toString())
    params.append('limit', limit.toString())
    if (role) params.append('role', role)
    if (status) params.append('status', status)

    const response = await apiClient.get<PaginatedResponse<User>>(
      `${ENDPOINT}?${params.toString()}`,
    )
    return response.data
  },

  getUserById: async (id: string) => {
    const response = await apiClient.get<User>(`${ENDPOINT}/${id}`)
    return response.data
  },

  createUser: async (data: UserCreateRequest) => {
    const response = await apiClient.post<User>(`${ENDPOINT}`, data)
    return response.data
  },

  updateUser: async (id: string, data: UserUpdateRequest) => {
    const response = await apiClient.patch<User>(`${ENDPOINT}/${id}`, data)
    return response.data
  },

  deleteUser: async (id: string) => {
    await apiClient.delete(`${ENDPOINT}/${id}`)
  },

  resetPassword: async (id: string, newPassword: string) => {
    const response = await apiClient.patch<User>(`${ENDPOINT}/${id}/reset-password`, {
      new_password: newPassword,
    })
    return response.data
  },
}
